export type ChatLog = {
  id: number;
  role: string;
  message: string;
  timestamp: string;
  chat_session: number | null;
}

export interface BrowserAgentLog {
  id?: number;
  url: string;
  title: string;
  image_url: string;
  session_id: number;
  network_logs: any[];
}

export interface NetworkLog extends Record<string, any> {
  url: string;
  method: string;
  headers?: Record<string, string>;
  request?: {
    url: string;
    method: string;
    headers?: Record<string, string>;
    postData?: string;
    postDataEntries?: { bytes: string }[];
    isSameSite?: boolean;
    hasPostData?: boolean;
    referrerPolicy?: string;
    initialPriority?: string;
    mixedContentType?: string;
  };
  postData?: string;
  response?: any;
  responseBody?: string;
  timestamp?: number;
  postData_encoding?: string;
}

export interface SavedNetworkPayload {
  id: number;
  label: string;
  description?: string;
  original_network_log: NetworkLog;
  updated_network_log: NetworkLog;
  extracted_url?: string;
  extracted_title?: string;
  saved_at: string;
}

export type SessionHistory = {
  id: number;
  start_time: string;
  end_time: string | null;
  first_message: string | null;
  is_browser: boolean;
}

export type IsBrowserStepsLoading = {
  message_id: number;
  isLoading: boolean;
}

export enum RequestStatuses {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed'
}

export enum ToolType {
  OSINT = 'osint',
  CODER = 'coder',
  BLANK = 'blank',
  BROWSER = 'browser',
}

type AuthState = {
  currentUser: string;
  token: string;
  userPicture: string;
}

type ChatState = {
  chatLog: ChatLog[];
  browserAgentLog: BrowserAgentLog[];
  currentSessionId: number;
  sessionHistory: SessionHistory[];
  sessionsWithBlockedUserPrompt: number[];
  isWebSocketOpen: boolean;
  fetchChatSessionHistoryStatus: RequestStatuses;
  sessionsWithSelectedTool: Record<number, ToolType>;
  isBrowserVisible: boolean;
  isBrowserStepsLoading: IsBrowserStepsLoading[];
  toolStatus: string;
}

type SubscriptionState = {
  isSubscribed: boolean;
  userMessageCount: number;
  numberOfMessagesBeforeCharge: number;
  isPaymentCardVisible: boolean;
  specialLimitApplies: boolean;
}

export type StateSchema = {
  auth: AuthState;
  chat: ChatState;
  subscription: SubscriptionState;
}

export type ThunkConfig = {
  state: StateSchema;
}

export type CheckAuthHandler = () => void;

export type SendMessageHandler = (message: string) => void;

export type StatusChangeHandler = (status: boolean) => void;
